import { Program } from '../../programs/shared/program.model';

export class Student {
  cedula: String;
  nombre: String;
  programas: Program[];

}
